<template>
  <div class="border-grey border-r-2 pr-8 mx-4">
    <h2 v-text="`Selected Members (${selectedMemberships.length})`" />
    <ul>
      <li
        v-for="membership in selectedMemberships"
        :key="membership.uuid"
        v-text="`${membership.attributes.first_name} ${membership.attributes.last_name}`"
      />
    </ul>
  </div>
</template>

<script type="text/babel">
import HasSelectedMemberships from 'Membership/Resources/assets/js/components/bulk-edit/mixins/HasSelectedMemberships'

export default {
  name: 'MembershipList',
  mixins: [HasSelectedMemberships],
}
</script>
